<avs-li-location-options
  (changed)="patchLocationForm($event)"
  [allRequired]="showFullLocation()"
  [config]="showFullLocation() ? locationConfig() : { locationId: locationConfig()?.locationId }"
  [type]="showFullLocation() ? 'room' : 'building'"
/>

@if (showDataType() && form.get('locationId')?.value) {
  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      Data type *
    </label>
    <mat-form-field
      class="select-classic has-validation flex-1"
      appearance="outline"
    >
      <mat-select
        (valueChange)="dataTypeChanged($event)"
        [value]="form.get('dataType')?.value"
        panelClass="single-select-overlay"
        placeholder="Select type"
      >
        @for (type of dataTypes; track type) {
          <mat-option [value]="type.value">
            {{ type.title | titlecase }}
          </mat-option>
        }
      </mat-select>
      <mat-icon
        class="arrow-down"
        matSuffix
      >
        keyboard_arrow_down
      </mat-icon>

      <mat-error>Input is not valid</mat-error>
    </mat-form-field>
  </div>
}

@if (showDataType() ? form.get('dataType')?.value : form.value?.roomId) {
  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      Devices *
    </label>

    <avs-li-device-selector
      class="flex-1"
      (changed)="patchForm({
        deviceId: $event,
        datapointName: undefined,
        dateRange: undefined
      })"
      [filters]="showDataType()
        ? { dataPoint: form.value?.dataType, location: form.value?.locationId }
        : { space : form.value?.roomId }"
      [value]="form.value.deviceId"
    />
  </div>
}

@if (form.value.deviceId) {
  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      Data Point *
    </label>
    <avs-li-data-point-selector
      class="flex-1"
      (changed)="patchForm({
        datapointName: $event,
        dateRange: hideDateRangeInput() ? eAvsDateRangeIds.LAST_7_DAYS : form.value?.dateRange
      })"
      [deviceId]="form.value.deviceId"
      [locationId]="form.value?.locationId"
      [value]="form.value?.datapointName"
    />
  </div>
}

@if (form.value?.datapointName && !hideDateRangeInput()) {
  <div class="flex flex-row mb-5">
    <label class="input-main-label capitalize">
      Period *
    </label>
    <avs-date-picker
      class="flex-1"
      (changedId)="patchForm({ dateRange: $event })"
      [config]="{
        customRange: false,
      }"
      [value]="form.value?.dateRange"
    />
  </div>
}
